var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaLiferingE00000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e00000",
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm173.7 119.6l-63.4 63.4c-11-18.6-26.7-34.3-45.3-45.3l63.4-63.4a218.4 218.4 0 0 1 45.3 45.3zM256 352c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM127.6 82.3l63.4 63.4c-18.6 11-34.3 26.7-45.3 45.3l-63.4-63.4a218.4 218.4 0 0 1 45.3-45.3zM82.3 384.4l63.4-63.4c11 18.6 26.7 34.3 45.3 45.3l-63.4 63.4a218.4 218.4 0 0 1 -45.3-45.3zm302.1 45.3l-63.4-63.4c18.6-11 34.3-26.7 45.3-45.3l63.4 63.4a218.4 218.4 0 0 1 -45.3 45.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaLiferingE00000);
export default __webpack_public_path__ + "static/media/fa-lifering-E00000.066a76fcf3ffc3a1592c2177c7bc1522.svg";
export { ForwardRef as ReactComponent };